"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsVelocityDialog = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var CollapsableItemList_1 = require("Reports/Common/CollapsableItemList");
var c = (0, BemBuilder_1.default)("velocity-help-dialog");
var items = [
    {
        id: "averagePageValue",
        title: "Average page value",
        description: "The average value of a page, including quote amounts or a value explicitly set for a page",
    },
    {
        id: "averageTimeToLive",
        title: "Average time live",
        description: (react_1.default.createElement(react_1.default.Fragment, null,
            "The average time it takes for a page to transition from live to accepted ",
            react_1.default.createElement("em", null, "or"),
            " declined, corresponding to the average time it takes to close a deal.")),
    },
    {
        id: "acceptRate",
        title: "Accept rate",
        description: "The percentage of all pages that transition to the accepted state in the reporting period.",
    },
];
var ReportsVelocityDialog = function () {
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement(icons_1.Velocity, { size: icons_1.IconSize.Medium, className: c("velocity-symbol") }),
        react_1.default.createElement(kaleidoscope_1.Label, { size: "m" }, "Sales velocity"),
        react_1.default.createElement("div", { className: c("description-group") },
            react_1.default.createElement(kaleidoscope_2.Text, { strong: true, align: "center", size: "s" }, "The sales velocity score is a single metric that combines effectiveness and efficiency."),
            react_1.default.createElement(kaleidoscope_1.Link, { href: "https://qwilr.com/blog/sales-velocity/" }, "How it works")),
        react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, null),
        react_1.default.createElement("div", { className: c("collapsible-item-list") }, items.length && (react_1.default.createElement("div", { className: "collapsible" }, items.map(function (item, index) { return (react_1.default.createElement(CollapsableItemList_1.CollapsableItemList, { key: item.id, label: item.title, showSeparator: index < items.length - 1 },
            react_1.default.createElement(kaleidoscope_2.Text, { strong: false, align: "left", size: "s" }, item.description))); }))))));
};
exports.ReportsVelocityDialog = ReportsVelocityDialog;
